import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import commonFunctions from '../../../utils/commonFunctions';
import API from '../../../utils/API';
import AlertCircle from '../../../assets/icons/alert-plus/alert-circle.svg';
import './SiteSelectionModal.css';

const SiteSelectionModal = ({ sites, selectedTemplate, refreshData, setSuccess, setError }) => {
  const { closeModal } = commonFunctions;
  const [selectedSites, setSelectedSites] = useState([]);

  useEffect(() => {
    if (selectedTemplate) {
      console.log('Template changed:', selectedTemplate);
    }
  }, [selectedTemplate]);

  const handleSelectAll = () => {
    if (selectedSites.length === sites.length) {
      setSelectedSites([]);
    } else {
      setSelectedSites(sites.map(site => site.id));
    }
  };

  const handleSiteToggle = (siteId) => {
    if (selectedSites.includes(siteId)) {
      setSelectedSites(selectedSites.filter(id => id !== siteId));
    } else {
      setSelectedSites([...selectedSites, siteId]);
    }
  };

  const handleTriggerAlert = async () => {
    try {
      await API.triggerAlert(selectedSites, selectedTemplate.id);
      setSuccess(<FormattedMessage id="ALERT_TRIGGER_SUCCESS" defaultMessage="Alert triggered successfully" />);
      closeModal('siteSelectionModal');
    } catch (error) {
      console.error('Error triggering alert:', error);
      setError(<FormattedMessage id="ALERT_TRIGGER_ERROR" defaultMessage="Error triggering alert" />);
    }
    refreshData();
  };

  return (
    <div className='modal fade' id="siteSelectionModal" tabIndex="-1" aria-labelledby='siteSelectionModalLabel'  aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><FormattedMessage id="SELECT_SITES_FOR_ALERT" defaultMessage="Select Sites for Alert" /></h5>
            <button type="button" className="btn-close" data-bs-dismiss='modal' aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="checkbox-group">
              <label className="checkbox-label selectAllText">
                <input
                  type="checkbox"
                  checked={selectedSites.length === sites.length}
                  onChange={handleSelectAll}
                />
                <FormattedMessage id="SELECT_ALL" defaultMessage="Select All" />
              </label>
              <div className="checkbox-group-inner">
                {sites.map(site => (
                  <label key={site.id} className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={selectedSites.includes(site.id)}
                      onChange={() => handleSiteToggle(site.id)}
                    />
                    {site.name}
                    {site.alert_in_progress && (
                      <span className="alert-in-progress-marker">
                        <img src={AlertCircle} alt="Alert in Progress" />
                        &nbsp;<FormattedMessage id="ALERT_IN_PROGRESS" defaultMessage="Alert in Progress" />
                      </span>
                    )}
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="modal-footer justify-content-between">
            <button id="cancelModalBtn" type="button" className="btn back-btn cancel-btn" data-bs-dismiss='modal'>
              <FormattedMessage id="CANCEL" defaultMessage="Cancel" />
            </button>
            <button id="triggerAlertBtn" className="trigger-alert-button" onClick={handleTriggerAlert}>
              <FormattedMessage id="TRIGGER_ALERT" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteSelectionModal;
